<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8" style="margin: 0 auto">
        <div @click="goBack">
          <mt-header title>
            <router-link to slot="left">
              <mt-button icon="back">{{ title }} </mt-button>
            </router-link>
          </mt-header>
        </div>
        <div class="form" v-if="cellName === 'mobile'">
          <mt-field
            class="inputTxt"
            placeholder="请输入手机号"
            type="number"
            v-model="user.mobile"
          ></mt-field>
          <div class="captchaBox">
            <mt-field
              placeholder="请输入验证码"
              v-model="captcha"
              :attr="{ maxlength: 6 }"
            ></mt-field>
            <mt-button
              type="primary"
              class="getcaptcha"
              @click="getCaptcha"
              v-if="sendAuthCode"
              >获取验证码</mt-button
            >
            <mt-button
              type="primary"
              class="getcaptcha"
              v-if="!sendAuthCode"
              :class="!sendAuthCode ? 'disableClass' : ''"
              >剩余{{ auth_time }}s</mt-button
            >
          </div>
          <div class="getBtn">
            <mt-button type="primary" class="btn" @click="regCaptcha"
              >更换绑定手机号</mt-button
            >
          </div>
        </div>
        <div class="form" v-if="cellName === 'nickName'">
          <mt-field
            class="inputTxt"
            placeholder="请输入昵称"
            v-model="user.nickName"
          ></mt-field>
          <div class="getBtn">
            <mt-button
              type="primary"
              class="btn"
              @click="updateUserInfo(user.nickName)"
              >保存</mt-button
            >
          </div>
        </div>
        <div class="form" v-if="cellName === 'name'">
          <mt-field
            class="inputTxt"
            placeholder="请输入真实姓名"
            v-model="user.name"
          ></mt-field>
          <div class="getBtn">
            <mt-button
              type="primary"
              class="btn"
              @click="updateUserInfo(user.name)"
              >保存</mt-button
            >
          </div>
        </div>

        <div class="form" v-if="cellName === 'avatar'">
          <div>
            <Avatar v-on:avatarInput="formUrl" class="upload" />
          </div>
          <div class="getBtn">
            <mt-button
              type="primary"
              class="btn"
              @click="updateUserInfo(avatar)"
              >保存</mt-button
            >
          </div>
        </div>
        <div class="form" v-if="cellName === 'gender'">
          <div class="radio_input">
            <span>请选择性别：</span>
            <input
              type="radio"
              name="gender"
              v-model="user.gender"
              :value="1"
            />男
            <input
              type="radio"
              name="gender"
              v-model="user.gender"
              :value="0"
            />女
          </div>
          <div class="getBtn">
            <mt-button
              type="primary"
              class="btn"
              @click="updateUserInfo(user.gender)"
              >保存</mt-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import { refreshToken } from '../../common/refreshToken'
import Avatar from '../../components/Avatar'
export default {
  components: { Avatar },
  data() {
    return {
      cellName: this.$route.query.cellName,
      usermobileStatus: '',
      captcha: '',
      sendAuthCode: true,
      auth_time: 0,
      user: {},
      loginType: true,
      send: false,
      disabled: false,
      title: '',
      avatar: '',
    }
  },
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    // this.getUser()
    if (this.cellName === 'nickName') {
      this.title = '修改昵称'
    }
    if (this.cellName === 'name') {
      this.title = '修改真实姓名'
    }

    if (this.cellName === 'avatar') {
      this.title = '修改头像'
    }

    if (this.cellName === 'gender') {
      this.title = '修改性别'
    }
    // 验证手机号
    if (this.cellName === 'mobile') {
      this.title = '更换绑定手机号'
    }
    this.noShare()
  },
  methods: {
    formUrl(avatar) {
      Indicator.close()
      if (avatar !== '') {
        this.user.avatar = avatar
        this.avatar = avatar
      } else {
        this.user.avatar = ''
      }
    },
    goBack() {
      this.$router.go(-2)
    },
    // 修改当前用户信息
    updateUserInfo(cellTitle) {
      if (!cellTitle) {
        if (this.cellName === 'nickName') {
          this.$toast('请输入昵称')
          return this
        }
        if (this.cellName === 'name') {
          this.$toast('请输入真实姓名')
          return this
        }

        if (this.cellName === 'avatar') {
          this.$toast('请选择头像')
          return this
        }
      }
      if (this.cellName === 'gender' && cellTitle !== 0 && cellTitle !== 1) {
        this.$toast('请选择性别')
        return this
      }
      if (this.cellName !== 'avatar' && cellTitle.length > 15) {
        this.$toast('不能超过15个字符')
        return this
      }
      this.$http({
        url: '/live/liveUsers/update',
        method: 'put',
        data: this.user,
      }).then(({ data }) => {
        if (data && data.code === 0) {
          refreshToken(this).then((res) => {
            if (res.code == 0) {
              this.$router.go(-1)
            }
          })
        } else {
          this.$toast(data.msg)
        }
      })
    },
    //验证码校验
    regCaptcha() {
      if (!this.user.mobile) {
        this.$toast('手机号不能为空')
        return this
      }
      if (!this.captcha) {
        this.$toast('验证码不能为空')
        return this
      }
      this.$http({
        url: `/live/liveUsers/check/${this.user.mobile}/${this.captcha}`,
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.updateUserInfo('mobile')
        } else {
          this.$toast(data.msg ? data.msg : '验证码错误')
          return this
        }
      })
    },
    //获取手机验证码
    getCaptcha() {
      if (!this.user.mobile) {
        this.$toast('请先输入手机号码')
        return
      }
      let mreg = /^1[0-9]{10}$/
      if (this.user.mobile.length <= 10 || !mreg.test(this.user.mobile)) {
        this.$toast('请输入正确的手机号')
        return this
      }
      this.$http({
        url: `/live/liveUsers/send/${this.user.mobile}`,
        method: 'get',
      }).then(({ data }) => {
        // this.$toast('验证码已发送')
      })
      this.sendAuthCode = false
      //设置倒计时秒
      this.auth_time = 60
      var auth_timetimer = setInterval(() => {
        this.auth_time--
        if (this.auth_time <= 0) {
          this.sendAuthCode = true
          clearInterval(auth_timetimer)
        }
      }, 1000)
    },
  },
}
</script>
<style lang='scss' scoped>
.disableClass {
  opacity: 0.6;
}
.radio_input {
  text-align: center;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 1rem 0;
  input {
    width: 24px;
    margin-left: 20px;
  }
}
.captchaBox {
  position: relative;
  .getcaptcha {
    position: absolute;
    top: 5px;
    right: 10px;
    line-height: 36px;
  }
}
.title {
  padding: 2rem;
  font-size: 24px;
  color: #999;
  span {
    padding: 0 1rem;
    color: #333;
  }
  span:nth-child(2) {
    color: $theme-color;
    font-size: 18px;
  }
}
.getBtn {
  box-sizing: border-box;
  margin-top: 20px;
  height: 55px;
  padding: 0 1rem;
  padding-bottom: 1rem;
  width: 100%;
  background-color: #fff;
  text-align: center;
}
.btn {
  width: 90%;
  height: 100%;
  font-size: $font-title;
  border-radius: 10px;
  line-height: 36px;
}
.btn:hover {
  color: #fff;
  text-decoration: none;
  border: none;
}
.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none;
}
.containe {
  width: 100%;
  height: 100%;
  background: #fbfbfb;
  .form {
    // border-top: 1rem solid #eee;
    padding: 0 1rem;
    .login {
      margin: 1rem;
      padding: 1rem 0;
      color: $theme-color;
      display: flex;
      justify-content: space-between;
      a {
        color: $theme-color;
      }
    }
  }
  .inputTxt {
    padding: 0;
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
  }

  .deal {
    text-align: center;
    margin: 2.4rem 0;
    .checkbox {
      position: relative;
      top: 2px;
    }
    a {
      color: $theme-color;
    }
  }
  /deep/ .mint-field-core {
    font-size: 1.4rem;
  }

  .btnBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .btn {
      padding: 0 20px;
      width: 76%;
    }
  }
  .context {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    p {
      text-align: center;
      margin: 0.4rem 0;
    }
  }
}
</style>
